import Header from "components/Headers/Header";
import Tabs from "components/Tabs";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Spinner,
} from "reactstrap";
import { searchManager } from "store/actions/managerAction";
import managerImage from "../../assets/img/custom/athleteAndManager.jpg";
import { getSeasonalManagerRatings } from "store/actions/managerAction";
import moment from "moment";
import { getTalkingManagerRatings } from "store/actions/managerAction";
import { getGroupChatManagerRatings } from "store/actions/managerAction";
import { clearSearch } from "store/actions/managerAction";
import { sendManagerEmail } from "store/actions/managerAction";
import { toast } from "react-toastify";
import { getManagerTotalRating } from "store/actions/managerAction";
import { getStrategyRating } from "store/actions/managerAction";
import ReuseableTable from "components/Tables/ReuseableTable";

const SearchManager = () => {
  let dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(false);
  const [ratingDataLoader, setRatingDataLoader] = useState(false);
  const [managerId, setManagerId] = useState("");
  const [managerRatingModal, setManagerRatingModal] = useState(false);
  const [managerEmailModal, setManagerEmailModal] = useState(false);
  const [email, setEmail] = useState({
    text: "",
    email: "",
  });
  let {
    searchedManager,
    managerSeasonalTotalRating,
    managerSeasonalRating,
    managerTalkingTotalRating,
    managerTalkingRating,
    managerMomentoTotalRating,
    managerMomentoRating,
    managerTotalRatings,
    strategyRating,
  } = useSelector((state) => state.manager);
  const toggleRatingModal = () => {
    setManagerRatingModal(!managerRatingModal);
  };
  const toggleEmailModal = () => {
    setManagerEmailModal(!managerEmailModal);
  };
  const handleSearchManager = () => {
    setDataLoader(true);
    dispatch(
      searchManager(managerId, () => {
        setDataLoader(false);
      })
    );
  };

  const SEASONAL_BADGE_TABLE_DATA = {
    columns: [
      "Athlete Name",
      "Athlete Email",
      "Athlete Id",
      "Feedback",
      "Remarks",
      "Rating",
      "Created At",
    ],
    keyMap: {
      "Athlete Name": "athleteName",
      "Athlete Email": "athleteEmail",
      "Athlete Id": "athleteId",
      Feedback: "feedback",
      Remarks: "remarks",
      Rating: "rating",
      "Created At": "createdAt",
    },
    data:
      managerSeasonalRating.length > 0 ? (
        managerSeasonalRating.map((item) => {
          return {
            athleteName: (
              <span className="text-nowrap">
                {item.athleteData.first_name + " " + item.athleteData.last_name}
              </span>
            ),
            athleteEmail: (
              <span className="text-nowrap">{item.athleteData.email}</span>
            ),
            athleteId: (
              <span className="text-nowrap">{item.athleteData.athleteID}</span>
            ),
            feedback: <span className="text-nowrap">{item.satisfactory}</span>,
            remarks: <span className="text-nowrap">{item.remarks} </span>,
            rating: (
              <span className="text-nowrap">{item.rating + " Start"}</span>
            ),
            createdAt: (
              <span className="text-nowrap">
                {moment.unix(item?.created_at?.seconds).format("DD MMM YYYY")}
              </span>
            ),
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
  };
  const MEMENTO_DATA = {
    columns: [
      "Athlete Name",
      "Athlete Email",
      "Athlete Id",
      "Feedback",
      "Remarks",
      "Rating",
      "Created At",
    ],
    keyMap: {
      "Athlete Name": "athleteName",
      "Athlete Email": "athleteEmail",
      "Athlete Id": "athleteId",
      Feedback: "feedback",
      Remarks: "remarks",
      Rating: "rating",
      "Created At": "createdAt",
    },
    data:
      managerMomentoRating.length > 0 ? (
        managerMomentoRating.map((item) => {
          return {
            athleteName: (
              <span className="text-nowrap">
                {item.athleteData.first_name + " " + item.athleteData.last_name}
              </span>
            ),
            athleteEmail: (
              <span className="text-nowrap">{item.athleteData.email}</span>
            ),
            athleteId: (
              <span className="text-nowrap">{item.athleteData.athleteID}</span>
            ),
            feedback: <span className="text-nowrap">{item.satisfactory}</span>,
            remarks: <span className="text-nowrap">{item.remarks} </span>,
            rating: (
              <span className="text-nowrap">{item.rating + " Start"}</span>
            ),
            createdAt: (
              <span className="text-nowrap">
                {moment.unix(item?.created_at?.seconds).format("DD MMM YYYY")}
              </span>
            ),
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
  };
  const TALKING_BADGE_TABLE_DATA = {
    columns: [
      "Athlete Name",
      "Athlete Email",
      "Athlete Id",
      "Feedback",
      "Remarks",
      "Rating",
      "Created At",
    ],
    keyMap: {
      "Athlete Name": "athleteName",
      "Athlete Email": "athleteEmail",
      "Athlete Id": "athleteId",
      Feedback: "feedback",
      Remarks: "remarks",
      Rating: "rating",
      "Created At": "createdAt",
    },
    data:
      managerTalkingRating.length > 0 ? (
        managerTalkingRating.map((item) => {
          return {
            athleteName: (
              <span className="text-nowrap">
                {item.athleteData.first_name + " " + item.athleteData.last_name}
              </span>
            ),
            athleteEmail: (
              <span className="text-nowrap">{item.athleteData.email}</span>
            ),
            athleteId: (
              <span className="text-nowrap">{item.athleteData.athleteID}</span>
            ),
            feedback: <span className="text-nowrap">{item.satisfactory}</span>,
            remarks: <span className="text-nowrap">{item.remarks} </span>,
            rating: (
              <span className="text-nowrap">{item.rating + " Start"}</span>
            ),
            createdAt: (
              <span className="text-nowrap">
                {moment.unix(item?.created_at?.seconds).format("DD MMM YYYY")}
              </span>
            ),
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
  };
  
  const STRATEGY_RATING_TABLE_DATA = {
    columns: [
      "Athlete Name",
      "Athlete Email",
      "Athlete Id",
      "Feedback",
      "Remarks",
      "Created At",
    ],
    keyMap: {
      "Athlete Name": "athleteName",
      "Athlete Email": "athleteEmail",
      "Athlete Id": "athleteId",
      Feedback: "feedback",
      Remarks: "remarks",
      "Created At": "createdAt",
    },
    data:
      strategyRating.length > 0 ? (
        strategyRating.map((item) => {
          return {
            athleteName: (
              <span className="text-nowrap">
                {item.athleteData.first_name + " " + item.athleteData.last_name}
              </span>
            ),
            athleteEmail: (
              <span className="text-nowrap">{item.athleteData.email}</span>
            ),
            athleteId: (
              <span className="text-nowrap">{item.athleteData.athleteID}</span>
            ),
            feedback: <span className="text-nowrap">{item.satisfactory}</span>,
            rating: (
              <span className="text-nowrap">{item.rating + " Start"}</span>
            ),
            createdAt: (
              <span className="text-nowrap">
                {moment.unix(item?.created_at?.seconds).format("DD MMM YYYY")}
              </span>
            ),
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
  };
  const tabs = [
    {
      id: "Seasonal Badge/view",
      title: "Seasonal Badge/view",
      content: ratingDataLoader ? (
        <p className="text-center">
          <Spinner color="primary" />
        </p>
      ) : (
        <>
          <h4 className="mb-4">
            Total Rating : S : {managerSeasonalTotalRating.satisfied} , NS :{" "}
            {managerSeasonalTotalRating.unSatisfied} , Rating :{" "}
            {managerSeasonalTotalRating.totalReviews > 0
              ? (
                  managerSeasonalTotalRating.rating /
                  managerSeasonalTotalRating.totalReviews
                ).toFixed(2)
              : "0"}
          </h4>
          <ReuseableTable {...SEASONAL_BADGE_TABLE_DATA} />
        </>
      ),
      onClick: () => {
        setRatingDataLoader(true);
        dispatch(
          getSeasonalManagerRatings(searchedManager[0].email, () => {
            setRatingDataLoader(false);
          })
        );
      },
    },
    {
      id: "Memento",
      title: "Memento",
      content: ratingDataLoader ? (
        <p className="text-center">
          <Spinner color="primary" />
        </p>
      ) : (
        <>
          <h4 className="mb-4">
            Total Rating : S : {managerMomentoTotalRating.satisfied} , NS :{" "}
            {managerMomentoTotalRating.unSatisfied} , Rating :{" "}
            {managerMomentoTotalRating.totalReviews > 0
              ? (
                  managerMomentoTotalRating.rating /
                  managerMomentoTotalRating.totalReviews
                ).toFixed(2)
              : "0"}
          </h4>
          <ReuseableTable {...MEMENTO_DATA} />
        </>
      ),
      onClick: () => {
        setRatingDataLoader(true);
        dispatch(
          getGroupChatManagerRatings(searchedManager[0].id, () => {
            setRatingDataLoader(false);
          })
        );
      },
    },
    {
      id: "Talking badge",
      title: "Talking badge",
      content: ratingDataLoader ? (
        <p className="text-center">
          <Spinner color="primary" />
        </p>
      ) : (
        <>
          <h4 className="mb-4">
            Total Rating : S : {managerTalkingTotalRating.satisfied} , NS :{" "}
            {managerTalkingTotalRating.unSatisfied} , Rating :{" "}
            {managerTalkingTotalRating.totalReviews > 0
              ? (
                  managerTalkingTotalRating.rating /
                  managerTalkingTotalRating.totalReviews
                ).toFixed(2)
              : "0"}
          </h4>
          <ReuseableTable {...TALKING_BADGE_TABLE_DATA} />
        </>
      ),
      onClick: () => {
        setRatingDataLoader(true);
        dispatch(
          getTalkingManagerRatings(searchedManager[0].email, () => {
            setRatingDataLoader(false);
          })
        );
      },
    },
    {
      id: "strategy-rating",
      title: "Strategy",
      content: ratingDataLoader ? (
        <p className="text-center">
          <Spinner color="primary" />
        </p>
      ) : (
        <>
          <h4 className="mb-4">
            Rating :{managerTotalRatings?.strategyRating || "0"}
          </h4>
          <ReuseableTable {...STRATEGY_RATING_TABLE_DATA} />
        </>
      ),
      onClick: () => {
        setRatingDataLoader(true);
        dispatch(
          getStrategyRating(searchedManager[0]?.email, () => {
            setRatingDataLoader(false);
          })
        );
      },
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const toggleTab = (tabId) => {
    setActiveTab(tabId);
    const selectedTab = tabs.find((tab) => tab.id === tabId);
    if (selectedTab && typeof selectedTab.onClick === "function") {
      selectedTab.onClick();
    }
  };
  const handleGetSeasonalRating = () => {
    setRatingDataLoader(true);
    dispatch(
      getSeasonalManagerRatings(searchedManager[0]?.email, () => {
        setRatingDataLoader(false);
      })
    );
  };

 const handleSendEmail = () => {
  setEmail((prev) => ({ ...prev, btnLoader: true }));

  const payload = {
    to: email.email,
    subject: "Athlete Email For Manager",
    text: email.text,
  };

  dispatch(
    sendManagerEmail(payload, () => {
      toast.success("Send Email Successfully");
      toggleEmailModal();
      setEmail({
        btnLoader: false,
        email: "",
        text: "",
      });
    })
  );
};


  const SEARCH_MANAGER_TABLE_DATA = {
    columns: [
      "Photo",
      "Manager Name",
      "Manager Email",
      "Manager Id",
      "Manager ratings",
    ],
    keyMap: {
      Photo: "photo",
      "Manager Name": "managerName",
      "Manager Email": "managerEmail",
      "Manager Id": "managerID",
      "Manager ratings": "managerRating",
    },
    data:
      searchedManager.length > 0 ? (
        searchedManager.map((item) => {
          return {
            photo: <img className="manager-profile" src={item.photo} />,
            managerName: <span className="text-nowrap">{item.name}</span>,
            managerEmail: <span className="text-nowrap">{item.email}</span>,
            managerID: <span className="text-nowrap">{item.managerID}</span>,
            managerRating: (
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  toggleRatingModal();
                  handleGetSeasonalRating(item);
                  dispatch(getManagerTotalRating(item.id));
                }}
              >
                See Rating
              </Button>
            ),
              email: item.email,
          };
        })
      ) : [],
    renderActions: (row, index) => {
      return (
        <Button
          color="primary"
          size="sm"
          onClick={() => {
            toggleEmailModal();
            setEmail((prev) => ({
  ...prev,
  email: row.email, 
}));
          }}
        >
          LET’S TALK
        </Button>
      );
    },
  };
  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        {/* Top Info Card explaining Manager program */}
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4 bg-white p-4">
          <Row className="align-items-center">
            <Col lg="8" className="mb-3 mb-lg-0">
              <span className="text-uppercase tracking-wider text-muted font-weight-700" style={{ fontSize: "10px", letterSpacing: "1px" }}>
                FHP MANAGER NETWORK
              </span>
              <h2 className="text-dark font-weight-800 mt-1 mb-3">
                Working with a Manager
              </h2>
              <p className="text-muted mb-3" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                A Manager can learn a lot by working with several FHP athletes. The manager might see how a smart athlete will <strong className="text-danger">alert his fans on social media</strong> when he posts a new Seasonal badge at FHP. 
              </p>
              <p className="text-muted mb-3" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                The manager might show an athlete how to <strong className="text-danger">adjust his profile video</strong> or his talent contest video <strong className="text-danger">to get the attention of fans</strong>.
              </p>
              <p className="text-muted mb-0" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                The manager might help the athlete get set up with a PayPal account. For teaching the student athlete about these secrets, the athlete might <strong className="text-danger">tip the manager on Zelle</strong>.
              </p>
            </Col>
            <Col lg="4" className="text-center d-none d-lg-block">
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "120px", height: "120px", backgroundColor: "#eef2ff", color: "#5e72e4" }}
              >
                <i className="fas fa-user-tie" style={{ fontSize: "3.5rem" }}></i>
              </div>
            </Col>
          </Row>
        </Card>

        {/* Search Card */}
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          <CardHeader className="bg-white border-0 pt-4 pb-0">
            <Row className="align-items-center justify-content-between">
              <Col xs="12" md="6" className="mb-3 mb-md-0">
                <h3 className="mb-0 text-dark font-weight-700 px-2">
                  <i className="fas fa-search text-primary mr-2"></i> Search Manager
                </h3>
              </Col>
              <Col xs="12" md="6">
                <div className="d-flex justify-content-md-end align-items-center" style={{ gap: "10px" }}>
                  <div style={{ minWidth: "220px" }}>
                    <Input
                      placeholder="Enter Manager ID (e.g. M862836420)"
                      value={managerId}
                      onChange={(e) => setManagerId(e.target.value)}
                      className="rounded-pill"
                    />
                  </div>
                  <Button
                    color="primary"
                    className="rounded-pill px-4"
                    onClick={handleSearchManager}
                    disabled={managerId.trim() === ""}
                  >
                    {dataLoader ? <Spinner size="sm" /> : "Search"}
                  </Button>
                  {managerId && (
                    <Button
                      color="secondary"
                      className="rounded-pill px-3"
                      onClick={() => {
                        dispatch(clearSearch());
                        setManagerId("");
                      }}
                    >
                      Clear
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </CardHeader>
          
          <div className="p-3">
            {dataLoader ? (
              <div className="text-center my-4">
                <Spinner color="primary" />
              </div>
            ) : (
              <ReuseableTable {...SEARCH_MANAGER_TABLE_DATA} />
            )}
          </div>
        </Card>
      </Container>

      <Modal
        isOpen={managerRatingModal}
        centered
        toggle={toggleRatingModal}
        size="xl"
      >
        <ModalBody>
          <h2 className="text-center">Manager Ratings</h2>
          <Card>
            <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
          </Card>
        </ModalBody>
        <ModalFooter className="text-right">
          <Button color="primary" size="sm" onClick={toggleRatingModal}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={managerEmailModal}
        centered
        toggle={toggleEmailModal}
        size="lg"
      >
        <ModalBody>
          <Input
            placeholder="Write Email Text"
            type="textarea"
            value={email.text}
            onChange={(e) =>
              setEmail((prev) => ({
                ...prev,
                text: e.target.value,
              }))
            }
          />
        </ModalBody>
        <ModalFooter className="text-right">
          <Button color="danger" size="sm" onClick={toggleEmailModal}>
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={handleSendEmail}
            disabled={email.btnLoader}
          >
            {email.btnLoader ? <Spinner size="sm" /> : "Send"}
          </Button>
        </ModalFooter>
      </Modal>

    </>
  );
};

export default SearchManager;
